import styled from '@emotion/styled';
import { LeftIcon, RightIcon } from './ShareModalIcons';
import { EmbedPosition } from './types';

const ToggleContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    flex: 1;
    margin-top: 20px;
    margin-bottom: 10px;
`;

const ToggleTitle = styled.div`
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: -0.32px;
`;

const OptionLabel = styled.div`
    color: #000;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
`;

const Option = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
`;

const Options = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    flex-direction: flex-row;
    cursor: pointer;
`;

interface Props {
    value: EmbedPosition;
    setValue: (next: EmbedPosition) => void;
}

export const PositionTabs = ({ value, setValue }: Props) => {
    return (
        <ToggleContainer>
            <ToggleTitle>Widget position</ToggleTitle>
            <Options>
                <Option onClick={() => setValue('left')}>
                    <LeftIcon active={value === 'left'} />
                    <OptionLabel>Left</OptionLabel>
                </Option>
                <Option onClick={() => setValue('right')}>
                    <RightIcon active={value === 'right'} />
                    <OptionLabel>Right</OptionLabel>
                </Option>
            </Options>
        </ToggleContainer>
    );
};
